export default __webpack_public_path__ + "static/logo27-8e5b3c9563e2688342adb4b173e0a173.png";